import { observable, runInAction } from 'mobx';
import {
  CommonDate,
  DropdownEquipment,
  DropdownRouting,
  ICommonDateServices,
  ListDate,
  ListStatusProduct,
} from 'services/commonDate_services';

export type commonDateStore = {
  commonDate: CommonDate;
  listDate: {
    data: ListDate[];
    message: string;
    isSuccess: boolean;
  };
  listStatusProductResponse: {
    data: Array<ListStatusProduct>;
    message: string;
    isSuccess: boolean;
  };
  listDropdownProduct: Array<ListStatusProduct>;
  // Lấy dropdown bằng keyword
  dropdownByKey: Array<ListStatusProduct>;
  // lấy dropdown công đoạn
  dropdownRouting: {
    data: DropdownRouting[];
    message: string;
    isSuccess: boolean;
  };
  // Lấy dropdown equipment
  dropdownEquipment: {
    data: DropdownEquipment[];
    message: string;
    isSuccess: boolean;
  };
  // danh sách khuôn (all)
  listMoldAll: Array<ListStatusProduct>;
};

export interface ICommonDatePresenter {
  createStore(): commonDateStore;
  getDataByCommonDate(store: commonDateStore, date: string | undefined): Promise<void>;
  getListCommonDate(store: commonDateStore, type?: string): Promise<void>;
  getListStatusProduct(store: commonDateStore): Promise<void>;
  getListDropdownProduct(store: commonDateStore, productCode: string, type?: string): Promise<void>;
  getDropdownByKeyword(store: commonDateStore, key: string): Promise<void>;
  // lấy dropdown bin
  getDropdownBin(store: commonDateStore, key: string): Promise<void>;
  // lấy dropdown Currentbin
  getDropdownCurrentBin(store: commonDateStore, key: string): Promise<void>;
  getDropdownRouting(store: commonDateStore, key?: string): Promise<void>;
  getDropdownWo(store: commonDateStore, woCode: string): Promise<void>;

  // getDropdown MoldTest Result
  getDropdownMoldTestResult(store: commonDateStore, keyWord: string): Promise<void>;

  // lấy dropdown nhân viên
  getDropdownSaleEmployee(store: commonDateStore, keyWord: string, toSX?: string[], actived?: boolean): Promise<void>;
  // Lấy dropdown equipment
  getDropdownEquipment(store: commonDateStore, keyWord: string): Promise<void>;

  // Lấy trạng thái máy móc
  getStatusEquipByID(id: string): Promise<string | undefined>;

  // Danh sách máy móc
  getListDropdownEquipmentV2(store: commonDateStore, key?: string): Promise<void>;
  // Danh sách khách hàng
  getListCustomer(store: commonDateStore, key?: string): Promise<void>;
  // Phân cấp sản phẩm
  getListPhanCapSP(key?: string): Promise<Array<ListStatusProduct>>;
  // load tất cả khuôn
  getAllMolds(store: commonDateStore): Promise<void>

}

export function createCommonDatePresenter({
  commonDateServices,
}: {
  commonDateServices: ICommonDateServices;
}): ICommonDatePresenter {
  return {
    createStore: (): commonDateStore =>
      observable({
        commonDate: {
          fromDate: '',
          toDate: '',
        },
        listDate: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listStatusProductResponse: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listDropdownProduct: [],
        dropdownByKey: [],
        // Dropdown công đoạn
        dropdownRouting: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // Dropdown Equipment
        dropdownEquipment: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // danh sách khuôn (all)
        listMoldAll: []
      }),
    getDataByCommonDate: async (store, date) => {
      try {
        const result = await commonDateServices.getDataByCommonDate(date);
        runInAction(() => {
          store.commonDate = result;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListCommonDate: async (store, type) => {
      try {
        const result = await commonDateServices.getListCommonDate(type);
        runInAction(() => {
          store.listDate = result;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListStatusProduct: async (store) => {
      try {
        const result = await commonDateServices.getListStatusProduct();
        runInAction(() => {
          store.listStatusProductResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListDropdownProduct: async (store: commonDateStore, productCode: string, type?: string) => {
      try {
        const result = await commonDateServices.getListDropdownProduct(productCode, type);
        runInAction(() => {
          store.listDropdownProduct = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDropdownByKeyword: async (store: commonDateStore, key: string) => {
      try {
        const result = await commonDateServices.getDropdownByKeyword(key);
        runInAction(() => {
          store.dropdownByKey = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy dropdown bin
    getDropdownBin: async (store: commonDateStore, key: string) => {
      try {
        const result = await commonDateServices.getDropdownBin(key);
        runInAction(() => {
          store.listStatusProductResponse.isSuccess = result.isSuccess;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy dropdown current bin
    getDropdownCurrentBin: async (store: commonDateStore, key: string) => {
      try {
        const result = await commonDateServices.getDropdownCurrentBin(key);
        runInAction(() => {
          store.listStatusProductResponse.isSuccess = result.isSuccess;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy dropdown routing
    getDropdownRouting: async (store: commonDateStore, key: string) => {
      try {
        const result = await commonDateServices.getDropdownRouting(key);
        runInAction(() => {
          store.dropdownRouting.isSuccess = result.isSuccess;
          store.dropdownRouting.message = result.message;
          store.dropdownRouting.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDropdownWo: async (store: commonDateStore, woCode: string) => {
      try {
        const result = await commonDateServices.getDropdownWo(woCode);
        runInAction(() => {
          store.listStatusProductResponse.data = result.data;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.isSuccess = result.isSuccess;
        });
      } catch { }
    },
    getDropdownMoldTestResult: async (store: commonDateStore, keyWord: string) => {
      try {
        const result = await commonDateServices.getDropdownMoldTestResult(keyWord);
        runInAction(() => {
          store.listStatusProductResponse.data = result.data;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.isSuccess = result.isSuccess;
        });
      } catch { }
    },
    getDropdownSaleEmployee: async (store: commonDateStore, keyWord: string, toSX?: string[], actived?: boolean) => {
      try {
        const result = await commonDateServices.getDropdownSaleEmployee(keyWord, toSX, actived);
        runInAction(() => {
          store.listStatusProductResponse.data = result.data;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.isSuccess = result.isSuccess;
        });
      } catch { }
    },
    getDropdownEquipment: async (store: commonDateStore, keyWord: string) => {
      try {
        const result = await commonDateServices.getDropdownEquipment(keyWord);
        runInAction(() => {
          store.dropdownEquipment.data = result.data;
          store.dropdownEquipment.message = result.message;
          store.dropdownEquipment.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Danh sách máy móc
    getListDropdownEquipmentV2: async (store: commonDateStore, keyWord: string) => {
      try {
        const result = await commonDateServices.getListDropdownEquipmentV2(keyWord);
        runInAction(() => {
          store.dropdownEquipment.data = result.data;
          store.dropdownEquipment.message = result.message;
          store.dropdownEquipment.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Danh sách khách hàng
    getListCustomer: async (store: commonDateStore, keyWord: string) => {
      try {
        const result = await commonDateServices.getListCustomer(keyWord);
        runInAction(() => {
          store.listStatusProductResponse.data = result.data;
          store.listStatusProductResponse.message = result.message;
          store.listStatusProductResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy trạng thái máy móc
    getStatusEquipByID: async (id: string) => {
      try {
        const result = await commonDateServices.getStatusEquipByID(id);
        return result;
      } catch (error) {
        console.log(error);
        return undefined;
      }
    },
    // Phân cấp sản phẩm
    getListPhanCapSP: async (key: string) => {
      try {
        const result = await commonDateServices.getListPhanCapSP(key);
        return result.data;
      } catch (error) {
        return [];
      }
    },
    // load tất cả khuôn
    getAllMolds: async (store) => {
      try {
        const result = await commonDateServices.getAllMolds();
        runInAction(() => {
          if (result && result.isSuccess) {
            store.listMoldAll = result.data;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
